// @flow

import { Component } from 'preact'

function shallowEqual (a: any, b: any) {
  for (let key in a) if (a[key] !== b[key]) return false
  for (let key in b) if (!(key in a)) return false
  return true
}

class PureComponent<Props, State> extends Component<Props, State> {
  shouldComponentUpdate (props: Props, state: State) {
    return !(shallowEqual(props, this.props) && shallowEqual(state, this.state))
  }
}

export default PureComponent



// WEBPACK FOOTER //
// ./src/lib/preact-pure-component.js